<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="关键词"
      :visible.sync="visible"
      width="1000px"
      @close="handleClose"
      class="amazon_category_dialog component"
    >
      <div class="keywords border-hover" style="--height:53px;">
        <div
          v-for="(record, index) in keywordList"
          :key="index"
          class="keyword"
        >
          <div class="mr-10px" style="">
            <div class="PRIMARY">{{ record.term }}</div>
            <div class="INFO mt-5px">{{ record.termCn }}</div>
          </div>
          <div style="display: none;">
            <div class="el-textarea el-input--suffix">
              <textarea
                autocomplete="off"
                class="el-textarea__inner"
                style="min-height: 33px;"
              ></textarea
              ><!---->
            </div>
          </div>
          <div @click="handleRemoveTerm(index)">
            <i class="fa fa-remove"></i>
          </div>
        </div>
        <div
          class="el-tooltip btn"
          aria-describedby="el-tooltip-9009"
          tabindex="0"
          @click="handleShowEdit({}, true)"
        >
          <i class="fa fa-plus"></i>
        </div>
      </div>
      <div class="box">
        <div class="group mr-10px">
          <div class="group-item">
            <div class="group_title">
              <span>分组</span
              ><i
                @click="handleShowTypeList"
                class="fa fa-cog f-r c-pointer"
              ></i>
            </div>
            <div
              @click="handleNodeClick({ typeId: '' })"
              role="treeitem"
              tabindex="-1"
              aria-disabled=""
              draggable="false"
              class="el-tree-node is-current is-focusable"
            >
              <div class="el-tree-node__content" style="padding-left: 0px;">
                <span
                  class="is-leaf el-tree-node__expand-icon el-icon-caret-right"
                ></span
                ><!----><!----><span class="el-tree-node__label">所有</span>
              </div>
              <!---->
            </div>
            <el-tree
              ref="tree"
              :data="setTree"
              :props="treeSelectProps"
              @node-click="handleNodeClick"
              default-expand-all
            ></el-tree>
          </div>
        </div>
        <div class="right">
          <div class="common-limit line-height-40">
            <div style="margin-top: 0;" class="form-body">
              <el-form
                ref="form"
                :model="queryParams"
                label-width="80px"
                size="small"
              >
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label="词：" prop="term">
                      <el-input
                        size="small"
                        v-model="queryParams.term"
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="中文词：" prop="termCn">
                      <el-input
                        size="small"
                        v-model="queryParams.termCn"
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col style="margin-top: 12px" :span="12">
                    <el-form-item label="添加时间：" prop="time">
                      <el-date-picker
                        v-model="queryParams.time"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col
                    style="margin-top: 8px"
                    :span="12"
                    class="btn-bar-right"
                  >
                    <div style="float:right;">
                      <el-button type="primary" size="small" @click="loadData"
                        >搜索</el-button
                      >
                      <el-button size="small" @click="resetForm"
                        >重置</el-button
                      >
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div style="padding-bottom: 0px;" class="form-body">
            <div style="overflow:hidden;">
              <span style="float:left;">
                <el-button
                  type="primary"
                  size="small"
                  @click="handleShowEdit({})"
                  >新增</el-button
                >
                <el-button size="small" @click="handleBatchImport()"
                  >导入词库</el-button
                >
              </span>
              <pagination
                v-show="total > 0"
                :total="total"
                :page.sync="queryParams.pageNum"
                :limit.sync="queryParams.pageSize"
                @pagination="loadData"
                :layout="'slot, total, sizes, prev, pager, next, jumper'"
              >
              </pagination>
            </div>
            <el-table
              ref="table"
              @selection-change="handleSelectionChange"
              style="height:300px;overflow-y: auto;"
              :data="tableData"
            >
              <el-table-column
                type="selection"
                width="55"
                align="center"
              ></el-table-column>
              <el-table-column label="关键词" prop="term" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.term }}
                  <br />
                  {{ scope.row.termCn }}
                </template>
              </el-table-column>
              <el-table-column
                label="分组"
                prop="typeName"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column prop="handel" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="mini"
                    @click="handleAddTerm(scope.row)"
                    >添加</el-button
                  >
                  <el-button
                    type="text"
                    size="mini"
                    @click="handleShowEdit(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="mini"
                    @click="deleteRow(scope.row)"
                    >删除</el-button
                  ><br />
                </template>
              </el-table-column>
            </el-table>
            <div style="overflow:hidden;">
              <div style="float:left;margin: 4px 0 0 0;">
                <el-button @click="handleBatchAddTerm" size="small"
                  >批量添加</el-button
                >
                <el-button @click="handleBatchDeleteTerm" size="small"
                  >批量删除</el-button
                >
                <el-button @click="handleShowTypeList" size="small"
                  >分组管理</el-button
                >
              </div>

              <pagination
                style="margin: 8px 0 0 0;float:right"
                class="bottom-sticky"
                v-show="total > 0"
                :total="total"
                :page.sync="queryParams.pageNum"
                :limit.sync="queryParams.pageSize"
                @pagination="loadData"
              />
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">关 闭</el-button>
        <el-button type="primary" @click="handleSubmit" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="配置分类"
      :visible.sync="classificationVisible"
      destroy-on-close
      width="800px"
    >
      <Classification
        :visible="classificationVisible"
        @close="closeClassification"
      ></Classification>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="editDialog.title"
      :visible.sync="editDialog.dialogVisible"
    >
      <el-form
        :model="editDialog.form"
        :rules="editDialog.rules"
        ref="advisoryForm"
        label-width="140px"
      >
        <el-form-item label="词" prop="term">
          <el-input size="small" v-model="editDialog.form.term"></el-input>
        </el-form-item>
        <el-form-item label="中文词" prop="termCn">
          <el-input size="small" v-model="editDialog.form.termCn"></el-input>
        </el-form-item>
        <el-form-item label="分组" prop="typeId">
          <TreeSelect
            :props="treeSelectProps"
            :options="setTree"
            v-model="editDialog.form.typeId"
            ref="childSelTree"
            style="width: 100%"
          ></TreeSelect>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editDialog.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleSave"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="`导入词库`"
      :visible.sync="importDialog.dialogVisible"
      width="600px"
    >
      <el-form
        :model="importDialog.form"
        :rules="importDialog.rules"
        ref="importForm"
        label-width="140px"
      >
        <el-form-item label="分组：" prop="typeId">
          <TreeSelect
            :props="treeSelectProps"
            :options="setTree"
            v-model="importDialog.form.typeId"
            ref="childSelTree"
            style="width: 100%"
          ></TreeSelect>
        </el-form-item>
        <el-form-item label="词：" prop="content">
          <el-input
            type="textarea"
            :rows="8"
            size="small"
            :placeholder="`竖线隔开，回车换行\n词库|中文词\n词库|中文词`"
            v-model="importDialog.form.content"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="importDialog.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleBatchSaveTerms"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSkuList } from "@/api/template/template"
import { mapGetters } from "vuex"
import { getCategorySuggestion } from "@/api/order/lazada"
import draggable from "vuedraggable"
import Classification from "./classification"
import TreeSelect from "@/components/common/treeSelect"
import {
  getQuestionList,
  addQuestion,
  updateQuestion,
  deleteQuestion,
} from "@/api/sysSupport/question"
import {
  getTermList,
  addTerm,
  editTerm,
  removeTerm,
} from "@/api/sysSupport/term"

import {
  addType,
  getTypeLlist,
  editType,
  deleteType,
  addBatch,
} from "@/api/sysSupport/term"

export default {
  name: "TermManageDialog",
  components: { draggable, Classification, TreeSelect },
  data() {
    return {
      tables: [],
      treeSelectProps: {
        value: "typeId", // ID字段名
        label: "typeName", // 显示名称
        children: "childrenTree", // 子级字段名
      },
      setTree: [],
      classificationVisible: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        term: "",
        termCn: "",
        beginTime: undefined,
        endTime: undefined,
        time: [],
        typeId: "",
      },
      total: 0,
      tableData: [],
      editDialog: {
        title: "",
        dialogVisible: false,
        form: {
          termId: "",
          term: "",
          termCn: "",
          typeId: "",
        },
        fileList: [],
        rules: {
          term: [{ required: true, message: "请选择词", trigger: "blur" }],
          termCn: [
            { required: true, message: "请输入中文词", trigger: "blur" },
          ],
        },
      },
      keywordList: [],
      selectionList: [],
      importDialog: {
        title: "",
        dialogVisible: false,
        form: {
          typeId: "",
          content: "",
        },
        rules: {
          typeId: [
            { required: true, message: "请选择分类", trigger: "change" },
          ],
          content: [
            { required: true, message: "请输入内容", trigger: "change" },
          ],
        },
      },
    }
  },
  watch: {
    visible: {
      handler() {
        this.keywordList = []
        this.$nextTick(() => {
          if (this.$refs.table) {
            this.$refs.table.clearSelection()
          }
        })
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["user", "dictMap", "dictData"]),
  },
  model: {
    prop: "visible",
    event: "change",
  },
  mounted() {
    this.getTypeLlist()
    this.loadData()
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    shopId: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleSubmit() {
      this.$emit("change", false)
      this.$emit("update", this.keywordList)
    },
    handleClose() {
      this.$emit("change", false)
    },
    handleBatchAddTerm() {
      if (this.selectionList.length == 0) {
        this.msgError("请选择词组")
        return
      }
      for (let selection of this.selectionList) {
        this.handleAddTerm(selection)
      }
    },
    handleBatchImport() {
      this.importDialog.form = {
        typeId: "",
        content: "",
      }
      this.importDialog.dialogVisible = true
    },
    handleBatchDeleteTerm() {
      if (this.selectionList.length == 0) {
        this.msgError("请选择词组")
        return
      }
      this.$confirm(
        `确认批量删除${this.selectionList.length}个词吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(async () => {
        let termIds = []
        for (let record of this.selectionList) {
          termIds.push(record.termId)
        }
        removeTerm({ termIds: termIds.join(",") }).then((response) => {
          if (response.code == "200") {
            this.$message.success("删除成功！")
            this.loadData()
          } else {
            this.$message.error("删除失败！")
          }
        })
      })
    },
    handleSelectionChange(val) {
      let list = []
      val.forEach((item) => {
        list.push(item)
      })
      this.selectionList = list
    },
    handleShowTypeList() {
      this.classificationVisible = true
    },
    async getTypeLlist() {
      this.isLoading = true
      const { rows } = await getTypeLlist({})
      this.isLoading = false
      if (rows) {
        this.setTree = rows
      }
    },
    closeClassification() {
      this.getTypeLlist()
      this.classificationVisible = false
    },
    /** 查询问题列表 */
    showClassification() {
      this.classificationVisible = true
    },
    handleNodeClick(node) {
      if (node) {
        this.queryParams.typeId = node.typeId
      } else {
        this.queryParams.typeId = ""
      }
      this.loadData()
    },
    loadData() {
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.manageTimeBegin = this.queryParams.time[0]
        this.queryParams.manageTimeEnd = this.queryParams.time[1]
      } else {
        this.queryParams.manageTimeBegin = undefined
        this.queryParams.manageTimeEnd = undefined
      }
      let params = this._.clone(this.queryParams)
      delete params["time"]
      getTermList(params)
        .then((response) => {
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    handleBatchSaveTerms() {
      this.$refs["importForm"].validate(async (valid) => {
        if (valid) {
          this.startLoading()
          addBatch(this.importDialog.form).then((response) => {
            if (response.code == "200") {
              this.$message.success("批量新增词组成功！")
              this.endLoading()
              this.loadData()
            } else {
              this.endLoading()
              this.$message.error("新增失败")
            }
            this.importDialog.dialogVisible = false
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    resetForm() {
      this.$refs["form"].resetFields()
    },
    handleChange(file, fileList) {
      if (file.size > 20 * 1024 * 1024) {
        this.msgWarning("文件不能大于20M")
        this.editDialog.fileList = []
      } else {
        this.editDialog.fileList = [file]
      }
    },
    /**显示编辑页面 */
    handleShowEdit(row, isAdd) {
      this.editDialog.isAdd = isAdd ? isAdd : false
      if (row.termId) {
        this.editDialog.form = Object.assign({}, row)
        this.editDialog.title = "编辑关键词"
      } else {
        this.editDialog.form = { isTop: "0" }
        this.editDialog.title = "新增关键词"
      }
      this.editDialog.dialogVisible = true
    },
    handleAddTerm(row) {
      let isExist = false
      for (let record of this.keywordList) {
        if (record.term == row.term) {
          isExist = true
          break
        }
      }

      if (!isExist) {
        this.keywordList.push(row)
      }
    },
    handleRemoveTerm(index) {
      this.keywordList.splice(index, 1)
    },
    deleteRow(row) {
      this.$confirm(
        '是否确定删除<span style="color: red">' + row.term + "</span>?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(function() {
          return removeTerm({ termIds: row.termId })
        })
        .then(() => {
          this.loadData()
          this.msgSuccess("删除成功")
        })
        .catch(function() {})
    },
    handleSave() {
      this.$refs["advisoryForm"].validate(async (valid) => {
        if (valid) {
          this.startLoading()
          this.editDialog.form.typeId = this.queryParams.typeId

          if (this.editDialog.form.termId) {
            editTerm(this.editDialog.form).then((response) => {
              if (response.code == "200") {
                this.$message.success("修改成功！")
                this.editDialog.dialogVisible = false
                this.endLoading()
                this.loadData()
              } else {
                this.endLoading()
                this.$message.error("修改失败")
              }
            })
          } else {
            addTerm(this.editDialog.form).then((response) => {
              if (response.code == "200") {
                this.$message.success("新增成功！")
                this.endLoading()
                this.editDialog.dialogVisible = false
                this.loadData()
                //添加词到词组
                if (this.editDialog.isAdd) {
                  this.handleAddTerm(this.editDialog.form)
                }
              } else {
                this.endLoading()
                this.$message.error("新增失败")
              }
            })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.avator img {
  width: 119px;
}
.avator {
}
.info {
  margin-left: 4px;
}
.amazon_category_dialog ::v-deep .el-dialog__footer {
  text-align: right;
}

.amazon_category_dialog ::v-deep .el-collapse-item__header {
  padding: 0px 8px;
  background-color: #f9f9f9;
}

.amazon_category_dialog ::v-deep .el-collapse-item__content {
  padding-bottom: 8px;
}

.text {
  text-align: center;
  margin: 24px 10px 15px 0;
  color: #909399;
}
.terms {
  margin: 0px 0 0 16px;
}
.add-button:hover {
  color: #4934b2;
}
.add-term-btn {
  border: 1px solid #ebeef5;
  width: 32px;
  height: 32px;
  text-align: center;
  border-radius: 3px;
  margin-bottom: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
  margin-top: 12px;
}
.fa-plus {
  line-height: 31px;
  color: #4934b2;
}
.component .box {
  display: flex;
}
.component .box .group {
  border: 1px solid #ebeef5;
}
.component .box .right {
  width: 100%;
}
.group {
  width: 200px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  background-color: #fff;
  border: 1px solid #ebeef5;
}
.mr-10px {
  margin-right: 10px;
}
.group .group_title {
  padding: 5px 15px;
  background: #fcfcfc;
  font-size: 13px;
  height: 33px;
  line-height: 33px;
  border-bottom: 1px solid #ebeef5;
}
.group .group_title .fa {
  position: relative;
  top: 10px;
  color: #333;
}

.c-pointer {
  cursor: pointer;
}
.f-r {
  float: right;
}

.keywords {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.keywords .el-textarea__inner {
  height: var(--height) !important;
  min-height: 32px !important;
}

.keywords .keyword {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  margin-right: 10px;
  border: 1px solid #ebeef5;
  padding: 7px 10px;
  border-radius: 3px;
  margin-bottom: 10px;
  line-height: 16px;
  cursor: pointer;
}

.keywords .keyword:hover {
  border: 1px solid #4934b2;
}

.keywords .keyword .fa-remove {
  cursor: pointer;
  color: #4934b2;
}

.keywords .keyword .fa-remove:hover {
  opacity: 0.8;
}

.keywords .btn {
  border: 1px solid #ebeef5;
  width: 32px;
  height: 32px;
  text-align: center;
  border-radius: 3px;
  margin-bottom: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}

.keywords .btn .fa-plus {
  line-height: 31px;
  color: #4934b2;
}

.keywords .el-textarea__inner {
  height: 56px;
  width: 130px;
}
.form-body ::v-deep .el-table::before {
  content: "";
  position: absolute;
  background-color: transparent;
  z-index: 1;
}
</style>
